import { PriceRange } from '@/components/blocks/PriceRange';
import { FacetNavigationPriceRangePicker } from '@/components/content/FacetNavigation/parts/PriceRangePicker';
import { priceRangeSX } from '@/components/content/FacetNavigation/styles/facetEntry/priceRange';
import { useFacetNavigation } from '@/data/Content/FacetNavigation';
import { ContentContext } from '@/data/context/content';
import { Chip } from '@mui/material';
import { FC, useCallback, useContext } from 'react';

export const FacetNavigationPrice: FC = () => {
	const { filteredParams, onPriceRangeChange } = useContext(ContentContext) as ReturnType<
		typeof useFacetNavigation
	>;
	const { minPrice = -1, maxPrice = -1 } = filteredParams;
	const onDelete = useCallback(
		() => onPriceRangeChange({ minPrice: null, maxPrice: null }),
		[onPriceRangeChange]
	);

	return minPrice > -1 && maxPrice > -1 ? (
		<Chip
			size="medium"
			label={<PriceRange min={minPrice} max={maxPrice} />}
			onClick={onDelete}
			onDelete={onDelete}
			data-testid="product-filter-formatted-price-chip"
			id="product-filter-formatted-price-chip"
			sx={priceRangeSX}
		/>
	) : (
		<FacetNavigationPriceRangePicker />
	);
};
